import React from "react";
import { Container } from "react-bootstrap";
import { RouterProvider, createBrowserRouter } from "react-router-dom";
import HomeScreen from "./home/HomeScreen";
import MenuHorizontal from "./menu/MenuHorizontal";
import ProfileDetails from "./profiles/ProfileDetails";
import ProfilesScreen from "./profiles/ProfilesScreen";
import SourceAdd from "./sources/SourceAdd";
import SourceDetails from "./sources/SourceDetails";
import SourcesScreen from "./sources/SourcesScreen";

const AdminLayout = ({ children }) => {
  const router = createBrowserRouter([
    {
      path: "/",
      element: <HomeScreen />,
    },
    {
      path: "/sources/:id",
      element: <SourceDetails />,
    },
    {
      path: "/sources",
      element: <SourcesScreen />,
    },
    {
      path: "/sources/new",
      element: <SourceAdd />,
    },
    {
      path: "/profiles",
      element: <ProfilesScreen />,
    },
    {
      path: "/profiles/:id",
      element: <ProfileDetails />,
    },
  ]);


  return (
    <React.Fragment>

      <Container className="container-main mt-4 rounded-top-4">
        <MenuHorizontal />
        <RouterProvider router={router} />
      </Container>
    </React.Fragment>
  );
}

export default AdminLayout;